import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LogoutConfirmationModalComponent } from './components/logout-confirmation-modal/logout-confirmation-modal.component';
import { DatePipe, DecimalPipe } from '@angular/common';
import { IonicStorageModule } from '@ionic/storage-angular';
import { Storage } from '@ionic/storage-angular';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ProfileModelPageModule } from './pages/profile-model/profile-model.module';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { ModalModule } from 'ngx-bootstrap/modal';

@NgModule({
	declarations: [AppComponent, LogoutConfirmationModalComponent],
	imports: [
		ModalModule.forRoot(),
		BrowserModule,
		BrowserAnimationsModule,
		IonicStorageModule.forRoot(),
		IonicModule.forRoot(),
		AppRoutingModule,
		NgbModule,
		ProfileModelPageModule
	],
	providers: [
		{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
		File,
		FileOpener,
		DecimalPipe,
		DatePipe,
		Storage,
		provideHttpClient(withInterceptorsFromDi())
	],
	bootstrap: [AppComponent]
})
export class AppModule {}
